<template>
  <div>
    <div class="content-wrapper">
      <div class="content">
        <h1 ref="title">{{ title }}</h1>
        <div class="question-text" ref="text" v-html="question"></div>
        <div class="button-wrapper">
          <hi-button-answer
            v-for="(answer, key) in answers"
            :key="key"
            :data-index="key"
            :correct_answer="answer.correct_answer"
          >
            <span>{{ answer.title }}</span>
          </hi-button-answer>
        </div>
      </div>
      <div class="illustration">
        <img :src="`/assets/static/ill-question-${quiz}.svg`" />
      </div>
    </div>
  </div>
</template>

<script>
import HIForm from "./../objects/HIForm.js";
import SessionMixin from "./../mixins/SessionCookieMixin";
import bus from "./../bus";
import Questions from "./../questions";
import Answers from "./../answers";
export default {
  mixins: [SessionMixin],
  data() {
    return {
      form: new HIForm({
        answer: "",
      }),
      quiz: null,
      question: "",
      session_id: null,
      color: "",
      theme: "",
      title: "",
    };
  },

  computed: {
    env() {
      return process.env;
    },
    quizMax() {
      return this.env.VUE_APP_NB_QUIZ;
    },

    answers() {
      if (this.quiz) {
        const responses = Answers[this.quiz];

        return responses.map(function (response) {
          return {
            id: response["id"],
            title: response["Title"],
            correct_answer: response["Vrai/faux"] == "Vrai",
          };
        });
      } else {
        return [];
      }
    },
  },

  mounted() {
    // window.history.forward(1); // Disable back button

    const vm = this;

    const record = this.fetchSession();
    const quiz = parseInt(this.$route.params.quiz) || record["Quiz"];
    if (quiz > this.quizMax) {
      vm.$router.push({ name: "Final" });
      return;
    }
    this.quiz = quiz;

    let session = this.$cookies.get("bci_session");
    session["Quiz"] = quiz;
    this.$cookies.set("bci_session", session);

    bus.$emit("quizUpdated", quiz);

    // Fetch the question from quiz number
    const question = Questions[quiz];
    const quest = question["Question"];

    this.title = question["Title"];
    this.question = quest;
    this.theme = question["Theme"];
    this.color = question["Color"];
  }, // end mounted
}; // end export
</script>
